var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { PlayStatus } from '../../../learnware/LearnwareEnums';
export class IntentAbort {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get intent() {
        return this.parent;
    }
    get shouldAbort() {
        if ([PlayStatus.Error, PlayStatus.Aborted, PlayStatus.Ended].includes(this.intent.playStatus)) {
            return false;
        }
        return this.isAbortConditionFulfilled;
    }
    get isAbortConditionFulfilled() {
        // is any of multiple abort condition ats fulfilled
        return this.intent.intentSettings.playbackAbortConditions
            .map(abortConditionKey => this.isSingleAbortConditionsFulfilled(abortConditionKey))
            .includes(true);
    }
    isSingleAbortConditionsFulfilled(abortConditionKey) {
        // innerhalb eines traits müssen alle Bedingungen erfüllt sein
        const pieces = abortConditionKey.split('_');
        if (pieces.length > 1) {
            return this[pieces[0]](pieces[1]);
        }
        return this[pieces[0]];
    }
    get isAlreadyPlaying() {
        return false; // is done in media reception
        return (this.intent.mediaPlayer.playerIntents.playingStartedAndPendingIntents.filter(intent => intent !== this.intent && intent.medFile === this.intent.medFile).length > 0);
    }
    get isConditionGone() {
        return !!this.intent.triggerAt && !this.intent.triggerAt.attachedCondition.evaluator.isConditionTrue;
    }
    get isOtherWaiting() {
        const channelIntents = this.intent.channel.intents;
        return !!channelIntents.find(intent => intent !== this.intent &&
            channelIntents.indexOf(intent) < channelIntents.indexOf(this.intent) &&
            [PlayStatus.Pending, PlayStatus.Go, PlayStatus.Playing].includes(intent.playStatus));
    }
}
__decorate([
    computed
], IntentAbort.prototype, "shouldAbort", null);
__decorate([
    computed
], IntentAbort.prototype, "isAbortConditionFulfilled", null);
__decorate([
    computed
], IntentAbort.prototype, "isAlreadyPlaying", null);
